export default () => ({
    flagTitle: {
        display: "block",
        "& > img": {
            verticalAlign: "text-bottom",
            marginRight: 5,
        },
    },
});